const validColorDepthValues = [1, 4, 8, 15, 16, 24, 32, 48];
const { colorDepth } = window.screen;

export const getColorDepth = () =>
  validColorDepthValues.includes(colorDepth)
    ? colorDepth
    : validColorDepthValues.toSorted(
        (a, b) =>
          Math.abs(screen.colorDepth - a) - Math.abs(screen.colorDepth - b),
      )[0];
